import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./routes/AppRouter"; // Import your router
import { ToastContainer } from "react-toastify"; // Import ToastContainer
import "react-toastify/dist/ReactToastify.css"; // Import Toast CSS
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import "./index.css";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-100">
        <AppRouter />
        <ToastContainer
          position="top-center" // Positions at the bottom center
          autoClose={1000}
          hideProgressBar={true} // Removes cartoonish progress bar
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          theme="light" // White background theme
          toastClassName="bg-white text-black shadow-md rounded-lg px-4 py-2"
          bodyClassName="text-gray-800 font-medium"
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
